import React from "react"
import { PropTypes } from "prop-types"
import moment from "moment"
import TranslatableParagraph from "../../common/components/translatable_paragraph/translatable_paragraph"
import "./HostInfo.scss"
import { Trans, withNamespaces } from "react-i18next"
import { compose } from "redux"

export class HostInfo extends React.Component {
  render() {
    const { t } = this.props
    return (
      <section>
        <h2 id="host">{t("navigation.host")}</h2>
        <div styleName="host-info">
          <div styleName="name-and-icon">
            <div styleName="name-block">
              <span styleName="host-name">{this.props.host.nickname}</span>
              <div>
                {this.props.host.area && this.props.host.area.trim() && (
                  <React.Fragment>
                    <span className="notranslate" styleName="host-area">
                      {this.props.host.area}
                    </span>
                    <span
                      className="notranslate"
                      styleName="host-area-separator"
                    >
                      ,
                    </span>
                  </React.Fragment>
                )}
                <span styleName="host-since">
                  <Trans i18nKey="host.member_since">
                    <span className="notranslate">
                      {{
                        year: moment(this.props.host.confirmed_at).format(
                          "YYYY"
                        )
                      }}
                    </span>
                    /
                    <span className="notranslate">
                      {{
                        month: moment(this.props.host.confirmed_at).format(
                          "MM"
                        )
                      }}
                    </span>
                    からメンバー
                  </Trans>
                </span>
              </div>
            </div>
            <div styleName="host-img-wrapper">
              <img
                styleName="host-img"
                src={
                  this.props.host.photo_url
                    ? this.props.host.photo_url
                    : "/assets/image/common/no_image.png"
                }
                alt=""
              />
            </div>
          </div>
          {this.props.host.introduction &&
            this.props.host.introduction.trim() && (
            <TranslatableParagraph
              content={this.props.host.introduction}
              className="introduction"
            ></TranslatableParagraph>
          )}
          {this.props.host.supported_languages &&
            this.props.host.supported_languages.length > 0 && (
            <dl styleName="languages">
              <dt>
                {t("host.language")}
                <span className="notranslate"> : </span>
              </dt>
              <dd>
                <span className="notranslate" styleName="language-list-text">
                  {this.props.host.supported_languages.join(", ")}
                </span>
              </dd>
            </dl>
          )}
        </div>
      </section>
    )
  }
}

HostInfo.propTypes = {
  host: PropTypes.object
}

HostInfo.defaultProps = {
  host: {}
}

export default compose(withNamespaces("listings"))(HostInfo)
